import { render, staticRenderFns } from "./Matomo.vue?vue&type=template&id=137f2f23&"
import script from "./Matomo.vue?vue&type=script&lang=js&"
export * from "./Matomo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Matomo.vue"
export default component.exports